import type { MonitorErrorResource } from "./monitorErrorResource";
export type FetchEventsResponse = {
    Events: EventResource[];
    IsSessionCompleted: boolean;
    Error: MonitorErrorResource | undefined;
};
type EventResource = {
    FirstObservedTime: string;
    LastObservedTime: string;
    Count: number;
    Action: string;
    Reason: string;
    Note: string;
    ReportingController: string;
    ReportingInstance: string;
    Type: KubernetesEventType;
    Manifest: string;
};
export const AllKubernetesEventTypes = ["Normal", "Warning"];
type KubernetesEventTypeTuple = typeof AllKubernetesEventTypes;
export type KubernetesEventType = KubernetesEventTypeTuple[number];
